<template>
	<ui-dialog
		ref="dialog"
		title="We're here to help"
		closable
	>
		<template v-if="!isSent">
			<p>Please visit our <a href="/help" target="_blank">help section</a> providing details on how to use the cloud service.</p>
			<p>You may also send us support question(s) using the form below and we will come back to you by e-mail, normally within 24 hours Monday - Friday.</p>
			<ui-text-area
				v-model="feedbackText"
				autofocus
				autogrow
				label="Message"
			/>
		</template>

		<template v-if="isSent">
			<p>Thank you for your message, we will reply shortly.</p>
		</template>

		<ui-dialog-footer>
			<ui-button
				v-if="!isSent"
				:disabled="isProcessing || feedbackText.length === 0"
				primary
				text="Send"
				tooltip="Send message"
				@click="postFeedback"
			/>

			<ui-button
				v-if="isSent"
				primary
				text="Close"
				@click="close"
			/>
		</ui-dialog-footer>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";
import UiTextArea from "lib/components/ui/TextArea";

export default {
	name: "FeedbackDialog",
	components: {
		UiButton,
		UiDialog,
		UiDialogFooter,
		UiTextArea
	},
	data() {
		return {
			feedbackText: "",
			isProcessing: false,
			isSent: false
		};
	},
	mounted() {
		this.open = () => {
			this.feedbackText = "";
			this.isSent = false;
			this.$refs.dialog.open();
		};
	},
	methods: {
		close() {
			this.$refs.dialog.close();
		},
		postFeedback() {
			this.isProcessing = true;

			http.post("/api/v2/feedback", {
				message: this.feedbackText
			})
			.then(() => {
				this.isSent = true;
			})
			.catch((error) => {
				alert.error("Unable to send feedback form", error.response);
			})
			.finally(() => {
				this.isProcessing = false;
			});
		}
	}
};
</script>
